const HighLow1 = [
    {id: "0", value: "高"},    
    {id: "1", value: "低"}, 
  ];  
  
  export default HighLow1